/**
 * SequenceProfile — UML Sequence / Communication / Timing diagrams.
 * See plans/software-design/domain.md § 3 for grammar and fragment subtypes.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type SequenceNodeType = 'seq_participant' | 'seq_actor' | 'seq_fragment';
export type SequenceEdgeType = 'sync_call' | 'async_call' | 'return_msg' | 'create_msg' | 'destroy_msg';

export const SequenceProfile: DomainDataProfile<SequenceNodeType, SequenceEdgeType> = {
  domainId: 'sequence',
  profileVersion: '1.0',
  diagramTypes: ['uml' as DiagramType],
  nodeTypes: ['seq_participant', 'seq_actor', 'seq_fragment'],
  edgeTypes: ['sync_call', 'async_call', 'return_msg', 'create_msg', 'destroy_msg'],
  vocabulary: {
    recordSingular: 'Participant',
    recordPlural: 'Participants',
    repositoryLabel: 'Interaction',
    hierarchyLabel: 'Call order',
    importAction: 'Import Sequence',
    keyColumnHint: 'Participant',
    commitLabel: 'Push Sequence',
    pullLabel: 'Refresh Sequence',
    diagramLabel: 'sequence diagram',
  },
  fieldAliases: {
    name: ['participant', 'actor'],
  },
  requiredProps: ['name'],
  recommendedProps: [],
  primaryShapeType: 'seq_participant',
  propsToAttrsMapping: {
    name: 'name',
    stereotype: 'stereotype',
    alias: 'alias',
  },
  relationshipPackId: 'software-design-relationships',
};
